import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="mt-5 rounded-2xl bg-danger-soft p-4 ring-1 ring-danger/25" data-id="element-55" data-mp="2l4o1b25i1tdy">
      <div className="flex items-center justify-between gap-3" data-id="element-56" data-mp="2q2puifwn3935">
        <p className="flex items-center gap-1.5 text-sm font-extrabold text-ink sm:text-base" data-id="element-57" data-mp="2b68lhvbxa6jr">
          <FlameIcon className="h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-58" data-mp="2g5l3o2rumpg0" />
          Only <span className="text-danger" data-id="element-59" data-mp="22621rrpmsac5">{SPOTS_LEFT} spots left</span> at the promotional price
        </p>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-danger/20" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-60" data-mp="274n1lq0z0s02">
        <motion.div className="h-full rounded-full bg-danger" initial={{
        width: '60%'
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-61" data-mp="33mmu2ryk25uj" />
      </div>
      <p className="mt-2 text-xs font-semibold text-muted" data-id="element-62" data-mp="3deis630n5vyr">
        {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} promotional spots claimed — the price returns to normal once they’re
        gone.
      </p>
    </div>;
}